import {
  coerceAtLeast2bkz8m9ik7hep as coerceAtLeast,
  coerceAtMost322komnqp70ag as coerceAtMost,
} from '../ranges/_Ranges.mjs';
import { takeHighestOneBit9p7rdtda63bc as takeHighestOneBit } from '../NumbersJs.mjs';
import {
  ConcurrentModificationException3974vl9oonkcj as ConcurrentModificationException,
  RuntimeException1r3t0zl97011n as RuntimeException,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  NoSuchElementException679xzhnp5bpj as NoSuchElementException,
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  UnsupportedOperationException2tkumpmhredt3 as UnsupportedOperationException,
} from '../exceptions.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../Unit.mjs';
import { Companion_instance2ztfx9zvq7j5d as Companion_instance } from './AbstractList.mjs';
import {
  copyOfUninitializedElements3uqjltwtgc0ej as copyOfUninitializedElements,
  arrayOfUninitializedElementsg6b068zrcm8j as arrayOfUninitializedElements,
  resetRangeiqi6axdujnmn as resetRange,
  resetAt1d0jjdeh7nn7m as resetAt,
} from './ArrayFunctions.mjs';
import { copyOf3rutauicler23 as copyOf } from './_ArraysJs.mjs';
import {
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
  toString1pkumu07cwy4m as toString,
  createThis2j2avj17cvnv2 as createThis,
  protoOf180f3jzyo7rfj as protoOf,
} from '../js/coreRuntime.mjs';
import {
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
} from '../hacks.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
import { _Char___init__impl__6a9atxrzocepzq3zgi as _Char___init__impl__6a9atx } from '../Char.mjs';
import {
  Entry2xmjmyutzoq3p as Entry,
  KtMap140uvy3s5zad8 as KtMap,
} from './Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../js/typeCheckUtils.mjs';
import { toString30pk9tzaqopn as toString_0 } from '../Library.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from '../text/StringBuilderJs.mjs';
import {
  containsAllEntries1q58uduc9e3y6 as containsAllEntries,
  InternalMap26d9hvxb47nvz as InternalMap,
} from './InternalMap.mjs';
//region block: imports
var imul = Math.imul;
var clz32 = Math.clz32;
//endregion
//region block: pre-declaration
//endregion
function computeHashSize($this, capacity) {
  return takeHighestOneBit(imul(coerceAtLeast(capacity, 1), 3));
}
function computeShift($this, hashSize) {
  // Inline function 'kotlin.countLeadingZeroBits' call
  return clz32(hashSize) + 1 | 0;
}
function checkForComodification($this) {
  if (!($this.map_1.modCount_1 === $this.expectedModCount_1))
    throw ConcurrentModificationException().new_kotlin_ConcurrentModificationException_snpq2y_k$('The backing map has been modified after this entry was obtained.');
}
function _get_capacity__a9k9f3($this) {
  return $this.keysArray_1.length;
}
function _get_hashSize__tftcho($this) {
  return $this.hashArray_1.length;
}
function registerModification($this) {
  $this.modCount_1 = $this.modCount_1 + 1 | 0;
}
function ensureExtraCapacity($this, n) {
  if (shouldCompact($this, n)) {
    compact($this, true);
  } else {
    ensureCapacity($this, $this.length_1 + n | 0);
  }
}
function shouldCompact($this, extraCapacity) {
  var spareCapacity = _get_capacity__a9k9f3($this) - $this.length_1 | 0;
  var gaps = $this.length_1 - $this.get_size_woubt6_k$() | 0;
  return spareCapacity < extraCapacity && (gaps + spareCapacity | 0) >= extraCapacity && gaps >= (_get_capacity__a9k9f3($this) / 4 | 0);
}
function ensureCapacity($this, minCapacity) {
  if (minCapacity < 0)
    throw RuntimeException().new_kotlin_RuntimeException_xu1s8h_k$('too many elements');
  if (minCapacity > _get_capacity__a9k9f3($this)) {
    var newSize = Companion_instance.newCapacity_k5ozfy_k$(_get_capacity__a9k9f3($this), minCapacity);
    $this.keysArray_1 = copyOfUninitializedElements($this.keysArray_1, newSize);
    var tmp = $this;
    var tmp0_safe_receiver = $this.valuesArray_1;
    tmp.valuesArray_1 = tmp0_safe_receiver == null ? null : copyOfUninitializedElements(tmp0_safe_receiver, newSize);
    $this.presenceArray_1 = copyOf($this.presenceArray_1, newSize);
    var newHashSize = computeHashSize(Companion_instance_0, newSize);
    if (newHashSize > _get_hashSize__tftcho($this)) {
      rehash($this, newHashSize);
    }
  }
}
function allocateValuesArray($this) {
  var curValuesArray = $this.valuesArray_1;
  if (!(curValuesArray == null))
    return curValuesArray;
  var newValuesArray = arrayOfUninitializedElements(_get_capacity__a9k9f3($this));
  $this.valuesArray_1 = newValuesArray;
  return newValuesArray;
}
function hash($this, key) {
  return key == null ? 0 : imul(hashCode(key), -1640531527) >>> $this.hashShift_1 | 0;
}
function compact($this, updateHashArray) {
  var i = 0;
  var j = 0;
  var valuesArray = $this.valuesArray_1;
  while (i < $this.length_1) {
    var hash = $this.presenceArray_1[i];
    if (hash >= 0) {
      $this.keysArray_1[j] = $this.keysArray_1[i];
      if (!(valuesArray == null)) {
        valuesArray[j] = valuesArray[i];
      }
      if (updateHashArray) {
        $this.presenceArray_1[j] = hash;
        $this.hashArray_1[hash] = j + 1 | 0;
      }
      j = j + 1 | 0;
    }
    i = i + 1 | 0;
  }
  resetRange($this.keysArray_1, j, $this.length_1);
  if (valuesArray == null)
    null;
  else {
    resetRange(valuesArray, j, $this.length_1);
  }
  $this.length_1 = j;
}
function rehash($this, newHashSize) {
  registerModification($this);
  if ($this.length_1 > $this._size_1) {
    compact($this, false);
  }
  $this.hashArray_1 = new Int32Array(newHashSize);
  $this.hashShift_1 = computeShift(Companion_instance_0, newHashSize);
  var i = 0;
  while (i < $this.length_1) {
    var _unary__edvuaz = i;
    i = _unary__edvuaz + 1 | 0;
    if (!putRehash($this, _unary__edvuaz)) {
      throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$('This cannot happen with fixed magic multiplier and grow-only hash array. Have object hashCodes changed?');
    }
  }
}
function putRehash($this, i) {
  var hash_0 = hash($this, $this.keysArray_1[i]);
  var probesLeft = $this.maxProbeDistance_1;
  while (true) {
    var index = $this.hashArray_1[hash_0];
    if (index === 0) {
      $this.hashArray_1[hash_0] = i + 1 | 0;
      $this.presenceArray_1[i] = hash_0;
      return true;
    }
    probesLeft = probesLeft - 1 | 0;
    if (probesLeft < 0)
      return false;
    var _unary__edvuaz = hash_0;
    hash_0 = _unary__edvuaz - 1 | 0;
    if (_unary__edvuaz === 0)
      hash_0 = _get_hashSize__tftcho($this) - 1 | 0;
  }
}
function findKey($this, key) {
  var hash_0 = hash($this, key);
  var probesLeft = $this.maxProbeDistance_1;
  while (true) {
    var index = $this.hashArray_1[hash_0];
    if (index === 0)
      return -1;
    if (equals($this.keysArray_1[index - 1 | 0], key))
      return index - 1 | 0;
    probesLeft = probesLeft - 1 | 0;
    if (probesLeft < 0)
      return -1;
    var _unary__edvuaz = hash_0;
    hash_0 = _unary__edvuaz - 1 | 0;
    if (_unary__edvuaz === 0)
      hash_0 = _get_hashSize__tftcho($this) - 1 | 0;
  }
}
function findValue($this, value) {
  var i = $this.length_1;
  $l$loop: while (true) {
    i = i - 1 | 0;
    if (!(i >= 0)) {
      break $l$loop;
    }
    if ($this.presenceArray_1[i] >= 0 && equals(ensureNotNull($this.valuesArray_1)[i], value))
      return i;
  }
  return -1;
}
function addKey($this, key) {
  $this.checkIsMutable_h5js84_k$();
  retry: while (true) {
    var hash_0 = hash($this, key);
    var tentativeMaxProbeDistance = coerceAtMost(imul($this.maxProbeDistance_1, 2), _get_hashSize__tftcho($this) / 2 | 0);
    var probeDistance = 0;
    while (true) {
      var index = $this.hashArray_1[hash_0];
      if (index === 0) {
        if ($this.length_1 >= _get_capacity__a9k9f3($this)) {
          ensureExtraCapacity($this, 1);
          continue retry;
        }
        var _unary__edvuaz = $this.length_1;
        $this.length_1 = _unary__edvuaz + 1 | 0;
        var putIndex = _unary__edvuaz;
        $this.keysArray_1[putIndex] = key;
        $this.presenceArray_1[putIndex] = hash_0;
        $this.hashArray_1[hash_0] = putIndex + 1 | 0;
        $this._size_1 = $this._size_1 + 1 | 0;
        registerModification($this);
        if (probeDistance > $this.maxProbeDistance_1)
          $this.maxProbeDistance_1 = probeDistance;
        return putIndex;
      }
      if (equals($this.keysArray_1[index - 1 | 0], key)) {
        return -index | 0;
      }
      probeDistance = probeDistance + 1 | 0;
      if (probeDistance > tentativeMaxProbeDistance) {
        rehash($this, imul(_get_hashSize__tftcho($this), 2));
        continue retry;
      }
      var _unary__edvuaz_0 = hash_0;
      hash_0 = _unary__edvuaz_0 - 1 | 0;
      if (_unary__edvuaz_0 === 0)
        hash_0 = _get_hashSize__tftcho($this) - 1 | 0;
    }
  }
}
function removeEntryAt($this, index) {
  resetAt($this.keysArray_1, index);
  var tmp0_safe_receiver = $this.valuesArray_1;
  if (tmp0_safe_receiver == null)
    null;
  else {
    resetAt(tmp0_safe_receiver, index);
  }
  removeHashAt($this, $this.presenceArray_1[index]);
  $this.presenceArray_1[index] = -1;
  $this._size_1 = $this._size_1 - 1 | 0;
  registerModification($this);
}
function removeHashAt($this, removedHash) {
  var hash_0 = removedHash;
  var hole = removedHash;
  var probeDistance = 0;
  while (true) {
    var _unary__edvuaz = hash_0;
    hash_0 = _unary__edvuaz - 1 | 0;
    if (_unary__edvuaz === 0)
      hash_0 = _get_hashSize__tftcho($this) - 1 | 0;
    var index = $this.hashArray_1[hash_0];
    probeDistance = probeDistance + 1 | 0;
    if (probeDistance > $this.maxProbeDistance_1) {
      $this.hashArray_1[hole] = 0;
      return Unit_instance;
    }
    if (index === 0) {
      $this.hashArray_1[hole] = 0;
      return Unit_instance;
    }
    var otherHash = hash($this, $this.keysArray_1[index - 1 | 0]);
    if (((otherHash - hash_0 | 0) & (_get_hashSize__tftcho($this) - 1 | 0)) >= probeDistance) {
      $this.hashArray_1[hole] = index;
      $this.presenceArray_1[index - 1 | 0] = hole;
      hole = hash_0;
      probeDistance = 0;
    }
  }
}
function contentEquals($this, other) {
  return $this._size_1 === other.get_size_woubt6_k$() && $this.containsAllEntries_5fw10l_k$(other.get_entries_p20ztl_k$());
}
function putEntry($this, entry) {
  var index = addKey($this, entry.get_key_18j28a_k$());
  var valuesArray = allocateValuesArray($this);
  if (index >= 0) {
    valuesArray[index] = entry.get_value_j01efc_k$();
    return true;
  }
  var oldValue = valuesArray[(-index | 0) - 1 | 0];
  if (!equals(entry.get_value_j01efc_k$(), oldValue)) {
    valuesArray[(-index | 0) - 1 | 0] = entry.get_value_j01efc_k$();
    return true;
  }
  return false;
}
function putAllEntries($this, from) {
  if (from.isEmpty_y1axqb_k$())
    return false;
  ensureExtraCapacity($this, from.get_size_woubt6_k$());
  var it = from.iterator_jk1svi_k$();
  var updated = false;
  while (it.hasNext_bitz1p_k$()) {
    if (putEntry($this, it.next_20eer_k$()))
      updated = true;
  }
  return updated;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        this.MAGIC_1 = -1640531527;
        this.INITIAL_CAPACITY_1 = 8;
        this.INITIAL_MAX_PROBE_DISTANCE_1 = 2;
        this.TOMBSTONE_1 = -1;
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance_0;
function Companion_getInstance() {
  return Companion_instance_0;
}
var ItrClass;
function Itr() {
  if (ItrClass === VOID) {
    class $ {
      constructor(map) {
        this.map_1 = map;
        this.index_1 = 0;
        this.lastIndex_1 = -1;
        this.expectedModCount_1 = this.map_1.modCount_1;
        this.initNext_evzkid_k$();
      }
      initNext_evzkid_k$() {
        while (this.index_1 < this.map_1.length_1 && this.map_1.presenceArray_1[this.index_1] < 0) {
          this.index_1 = this.index_1 + 1 | 0;
        }
      }
      hasNext_bitz1p_k$() {
        return this.index_1 < this.map_1.length_1;
      }
      remove_ldkf9o_k$() {
        this.checkForComodification_o4dljl_k$();
        // Inline function 'kotlin.check' call
        if (!!(this.lastIndex_1 === -1)) {
          var message = 'Call next() before removing element from the iterator.';
          throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$(toString(message));
        }
        this.map_1.checkIsMutable_h5js84_k$();
        removeEntryAt(this.map_1, this.lastIndex_1);
        this.lastIndex_1 = -1;
        this.expectedModCount_1 = this.map_1.modCount_1;
      }
      checkForComodification_o4dljl_k$() {
        if (!(this.map_1.modCount_1 === this.expectedModCount_1))
          throw ConcurrentModificationException().new_kotlin_ConcurrentModificationException_fy07nh_k$();
      }
    }
    initMetadataForClass($, 'Itr');
    ItrClass = $;
  }
  return ItrClass;
}
var KeysItrClass;
function KeysItr() {
  if (KeysItrClass === VOID) {
    class $ extends Itr() {
      next_20eer_k$() {
        this.checkForComodification_o4dljl_k$();
        if (this.index_1 >= this.map_1.length_1)
          throw NoSuchElementException().new_kotlin_NoSuchElementException_wy3d4q_k$();
        var tmp = this;
        var _unary__edvuaz = this.index_1;
        this.index_1 = _unary__edvuaz + 1 | 0;
        tmp.lastIndex_1 = _unary__edvuaz;
        var result = this.map_1.keysArray_1[this.lastIndex_1];
        this.initNext_evzkid_k$();
        return result;
      }
    }
    initMetadataForClass($, 'KeysItr');
    KeysItrClass = $;
  }
  return KeysItrClass;
}
var ValuesItrClass;
function ValuesItr() {
  if (ValuesItrClass === VOID) {
    class $ extends Itr() {
      next_20eer_k$() {
        this.checkForComodification_o4dljl_k$();
        if (this.index_1 >= this.map_1.length_1)
          throw NoSuchElementException().new_kotlin_NoSuchElementException_wy3d4q_k$();
        var tmp = this;
        var _unary__edvuaz = this.index_1;
        this.index_1 = _unary__edvuaz + 1 | 0;
        tmp.lastIndex_1 = _unary__edvuaz;
        var result = ensureNotNull(this.map_1.valuesArray_1)[this.lastIndex_1];
        this.initNext_evzkid_k$();
        return result;
      }
    }
    initMetadataForClass($, 'ValuesItr');
    ValuesItrClass = $;
  }
  return ValuesItrClass;
}
var EntriesItrClass;
function EntriesItr() {
  if (EntriesItrClass === VOID) {
    class $ extends Itr() {
      next_20eer_k$() {
        this.checkForComodification_o4dljl_k$();
        if (this.index_1 >= this.map_1.length_1)
          throw NoSuchElementException().new_kotlin_NoSuchElementException_wy3d4q_k$();
        var tmp = this;
        var _unary__edvuaz = this.index_1;
        this.index_1 = _unary__edvuaz + 1 | 0;
        tmp.lastIndex_1 = _unary__edvuaz;
        var result = new (EntryRef())(this.map_1, this.lastIndex_1);
        this.initNext_evzkid_k$();
        return result;
      }
      nextHashCode_b13whm_k$() {
        if (this.index_1 >= this.map_1.length_1)
          throw NoSuchElementException().new_kotlin_NoSuchElementException_wy3d4q_k$();
        var tmp = this;
        var _unary__edvuaz = this.index_1;
        this.index_1 = _unary__edvuaz + 1 | 0;
        tmp.lastIndex_1 = _unary__edvuaz;
        // Inline function 'kotlin.hashCode' call
        var tmp0_safe_receiver = this.map_1.keysArray_1[this.lastIndex_1];
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
        var tmp_0 = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
        // Inline function 'kotlin.hashCode' call
        var tmp0_safe_receiver_0 = ensureNotNull(this.map_1.valuesArray_1)[this.lastIndex_1];
        var tmp1_elvis_lhs_0 = tmp0_safe_receiver_0 == null ? null : hashCode(tmp0_safe_receiver_0);
        var result = tmp_0 ^ (tmp1_elvis_lhs_0 == null ? 0 : tmp1_elvis_lhs_0);
        this.initNext_evzkid_k$();
        return result;
      }
      nextAppendString_konuli_k$(sb) {
        if (this.index_1 >= this.map_1.length_1)
          throw NoSuchElementException().new_kotlin_NoSuchElementException_wy3d4q_k$();
        var tmp = this;
        var _unary__edvuaz = this.index_1;
        this.index_1 = _unary__edvuaz + 1 | 0;
        tmp.lastIndex_1 = _unary__edvuaz;
        var key = this.map_1.keysArray_1[this.lastIndex_1];
        if (equals(key, this.map_1))
          sb.append_22ad7x_k$('(this Map)');
        else
          sb.append_t8pm91_k$(key);
        sb.append_58al37_k$(_Char___init__impl__6a9atx(61));
        var value = ensureNotNull(this.map_1.valuesArray_1)[this.lastIndex_1];
        if (equals(value, this.map_1))
          sb.append_22ad7x_k$('(this Map)');
        else
          sb.append_t8pm91_k$(value);
        this.initNext_evzkid_k$();
      }
    }
    initMetadataForClass($, 'EntriesItr');
    EntriesItrClass = $;
  }
  return EntriesItrClass;
}
var EntryRefClass;
function EntryRef() {
  if (EntryRefClass === VOID) {
    class $ {
      constructor(map, index) {
        this.map_1 = map;
        this.index_1 = index;
        this.expectedModCount_1 = this.map_1.modCount_1;
      }
      get_key_18j28a_k$() {
        checkForComodification(this);
        return this.map_1.keysArray_1[this.index_1];
      }
      get_value_j01efc_k$() {
        checkForComodification(this);
        return ensureNotNull(this.map_1.valuesArray_1)[this.index_1];
      }
      equals(other) {
        var tmp;
        var tmp_0;
        if (!(other == null) ? isInterface(other, Entry()) : false) {
          tmp_0 = equals(other.get_key_18j28a_k$(), this.get_key_18j28a_k$());
        } else {
          tmp_0 = false;
        }
        if (tmp_0) {
          tmp = equals(other.get_value_j01efc_k$(), this.get_value_j01efc_k$());
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        // Inline function 'kotlin.hashCode' call
        var tmp0_safe_receiver = this.get_key_18j28a_k$();
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
        var tmp = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
        // Inline function 'kotlin.hashCode' call
        var tmp0_safe_receiver_0 = this.get_value_j01efc_k$();
        var tmp1_elvis_lhs_0 = tmp0_safe_receiver_0 == null ? null : hashCode(tmp0_safe_receiver_0);
        return tmp ^ (tmp1_elvis_lhs_0 == null ? 0 : tmp1_elvis_lhs_0);
      }
      toString() {
        return toString_0(this.get_key_18j28a_k$()) + '=' + toString_0(this.get_value_j01efc_k$());
      }
    }
    initMetadataForClass($, 'EntryRef', VOID, VOID, [Entry()]);
    EntryRefClass = $;
  }
  return EntryRefClass;
}
var InternalHashMapClass;
function InternalHashMap() {
  if (InternalHashMapClass === VOID) {
    class $ {
      constructor(keysArray, valuesArray, presenceArray, hashArray, maxProbeDistance, length) {
        return new.target.new_kotlin_collections_InternalHashMap_xusumo_k$(keysArray, valuesArray, presenceArray, hashArray, maxProbeDistance, length);
      }
      static new_kotlin_collections_InternalHashMap_xusumo_k$(keysArray, valuesArray, presenceArray, hashArray, maxProbeDistance, length) {
        var $this = createThis(this);
        $this.keysArray_1 = keysArray;
        $this.valuesArray_1 = valuesArray;
        $this.presenceArray_1 = presenceArray;
        $this.hashArray_1 = hashArray;
        $this.maxProbeDistance_1 = maxProbeDistance;
        $this.length_1 = length;
        $this.hashShift_1 = computeShift(Companion_instance_0, _get_hashSize__tftcho($this));
        $this.modCount_1 = 0;
        $this._size_1 = 0;
        $this.isReadOnly_1 = false;
        return $this;
      }
      get_size_woubt6_k$() {
        return this._size_1;
      }
      static new_kotlin_collections_InternalHashMap_iefrky_k$() {
        return this.new_kotlin_collections_InternalHashMap_jnbws6_k$(8);
      }
      static new_kotlin_collections_InternalHashMap_jnbws6_k$(initialCapacity) {
        return this.new_kotlin_collections_InternalHashMap_xusumo_k$(arrayOfUninitializedElements(initialCapacity), null, new Int32Array(initialCapacity), new Int32Array(computeHashSize(Companion_instance_0, initialCapacity)), 2, 0);
      }
      static new_kotlin_collections_InternalHashMap_c4hmjh_k$(original) {
        var $this = this.new_kotlin_collections_InternalHashMap_jnbws6_k$(original.get_size_woubt6_k$());
        $this.putAll_wgg6cj_k$(original);
        return $this;
      }
      static new_kotlin_collections_InternalHashMap_uj162q_k$(initialCapacity, loadFactor) {
        var $this = this.new_kotlin_collections_InternalHashMap_jnbws6_k$(initialCapacity);
        // Inline function 'kotlin.require' call
        if (!(loadFactor > 0)) {
          var message = 'Non-positive load factor: ' + loadFactor;
          throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message));
        }
        return $this;
      }
      build_52xuhq_k$() {
        this.checkIsMutable_h5js84_k$();
        this.isReadOnly_1 = true;
      }
      containsValue_yf2ykl_k$(value) {
        return findValue(this, value) >= 0;
      }
      get_wei43m_k$(key) {
        var index = findKey(this, key);
        if (index < 0)
          return null;
        return ensureNotNull(this.valuesArray_1)[index];
      }
      contains_vbgn2f_k$(key) {
        return findKey(this, key) >= 0;
      }
      put_4fpzoq_k$(key, value) {
        var index = addKey(this, key);
        var valuesArray = allocateValuesArray(this);
        if (index < 0) {
          var oldValue = valuesArray[(-index | 0) - 1 | 0];
          valuesArray[(-index | 0) - 1 | 0] = value;
          return oldValue;
        } else {
          valuesArray[index] = value;
          return null;
        }
      }
      putAll_wgg6cj_k$(from) {
        this.checkIsMutable_h5js84_k$();
        putAllEntries(this, from.get_entries_p20ztl_k$());
      }
      remove_gppy8k_k$(key) {
        this.checkIsMutable_h5js84_k$();
        var index = findKey(this, key);
        if (index < 0)
          return null;
        var oldValue = ensureNotNull(this.valuesArray_1)[index];
        removeEntryAt(this, index);
        return oldValue;
      }
      clear_j9egeb_k$() {
        this.checkIsMutable_h5js84_k$();
        var inductionVariable = 0;
        var last = this.length_1 - 1 | 0;
        if (inductionVariable <= last)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var hash = this.presenceArray_1[i];
            if (hash >= 0) {
              this.hashArray_1[hash] = 0;
              this.presenceArray_1[i] = -1;
            }
          }
           while (!(i === last));
        resetRange(this.keysArray_1, 0, this.length_1);
        var tmp0_safe_receiver = this.valuesArray_1;
        if (tmp0_safe_receiver == null)
          null;
        else {
          resetRange(tmp0_safe_receiver, 0, this.length_1);
        }
        this._size_1 = 0;
        this.length_1 = 0;
        registerModification(this);
      }
      equals(other) {
        var tmp;
        if (other === this) {
          tmp = true;
        } else {
          var tmp_0;
          if (!(other == null) ? isInterface(other, KtMap()) : false) {
            tmp_0 = contentEquals(this, other);
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        }
        return tmp;
      }
      hashCode() {
        var result = 0;
        var it = this.entriesIterator_or017i_k$();
        while (it.hasNext_bitz1p_k$()) {
          result = result + it.nextHashCode_b13whm_k$() | 0;
        }
        return result;
      }
      toString() {
        var sb = StringBuilder().new_kotlin_text_StringBuilder_wcb3z_k$(2 + imul(this._size_1, 3) | 0);
        sb.append_22ad7x_k$('{');
        var i = 0;
        var it = this.entriesIterator_or017i_k$();
        while (it.hasNext_bitz1p_k$()) {
          if (i > 0) {
            sb.append_22ad7x_k$(', ');
          }
          it.nextAppendString_konuli_k$(sb);
          i = i + 1 | 0;
        }
        sb.append_22ad7x_k$('}');
        return sb.toString();
      }
      checkIsMutable_h5js84_k$() {
        if (this.isReadOnly_1)
          throw UnsupportedOperationException().new_kotlin_UnsupportedOperationException_cv3bvm_k$();
      }
      removeKey_ijmwbh_k$(key) {
        this.checkIsMutable_h5js84_k$();
        var index = findKey(this, key);
        if (index < 0)
          return false;
        removeEntryAt(this, index);
        return true;
      }
      containsEntry_jg6xfi_k$(entry) {
        var index = findKey(this, entry.get_key_18j28a_k$());
        if (index < 0)
          return false;
        return equals(ensureNotNull(this.valuesArray_1)[index], entry.get_value_j01efc_k$());
      }
      containsOtherEntry_yvdc55_k$(entry) {
        return this.containsEntry_jg6xfi_k$(isInterface(entry, Entry()) ? entry : THROW_CCE());
      }
      removeEntry_dxtz15_k$(entry) {
        this.checkIsMutable_h5js84_k$();
        var index = findKey(this, entry.get_key_18j28a_k$());
        if (index < 0)
          return false;
        if (!equals(ensureNotNull(this.valuesArray_1)[index], entry.get_value_j01efc_k$()))
          return false;
        removeEntryAt(this, index);
        return true;
      }
      removeValue_ccp5hc_k$(value) {
        this.checkIsMutable_h5js84_k$();
        var index = findValue(this, value);
        if (index < 0)
          return false;
        removeEntryAt(this, index);
        return true;
      }
      keysIterator_mjslfm_k$() {
        return new (KeysItr())(this);
      }
      valuesIterator_3ptos0_k$() {
        return new (ValuesItr())(this);
      }
      entriesIterator_or017i_k$() {
        return new (EntriesItr())(this);
      }
    }
    protoOf($).containsAllEntries_5fw10l_k$ = containsAllEntries;
    initMetadataForClass($, 'InternalHashMap', $.new_kotlin_collections_InternalHashMap_iefrky_k$, VOID, [InternalMap()]);
    InternalHashMapClass = $;
  }
  return InternalHashMapClass;
}
//region block: init
Companion_instance_0 = new (Companion())();
//endregion
//region block: exports
export {
  InternalHashMap as InternalHashMapmpvpylj0ut6l,
};
//endregion

//# sourceMappingURL=InternalHashMap.mjs.map
